import { render, staticRenderFns } from "./Applet.vue?vue&type=template&id=6dc283a6&scoped=true&"
import script from "./Applet.vue?vue&type=script&lang=js&"
export * from "./Applet.vue?vue&type=script&lang=js&"
import style0 from "./Applet.vue?vue&type=style&index=0&id=6dc283a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc283a6",
  null
  
)

export default component.exports